import { render } from "./PpcSbStrategiesModal.vue?vue&type=template&id=296a14de&scoped=true"
import script from "./PpcSbStrategiesModal.vue?vue&type=script&lang=js"
export * from "./PpcSbStrategiesModal.vue?vue&type=script&lang=js"

import "./PpcSbStrategiesModal.vue?vue&type=style&index=0&id=296a14de&lang=scss"
import "./PpcSbStrategiesModal.vue?vue&type=style&index=1&id=296a14de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296a14de"]])

export default __exports__